import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{staticClass:"mx-0",style:({width: _vm.widthPX}),attrs:{"x-small":_vm.xSmallBtn,"small":_vm.smallBtn,"disabled":_vm.disabled,"color":_vm.color,"icon":_vm.isIconButton,"block":_vm.block},on:{"click":_vm.goToAction}},[_c(VIcon,{attrs:{"color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n    "+_vm._s(_vm.text)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }